// single pages
import homePage from '../pages/Home.vue'
import introPage from '../pages/Intro.vue'
import contactPage from '../pages/Contact.vue'
import GalleryPage from '../pages/Gallery.vue'
import notFoundPage from '../pages/NotFound.vue'

import { routePropResolver } from './util'
import { DOMAIN_TITLE } from '../.env'

export const routes = [
  {
    path: '/',
    name: 'index',
    component: homePage,
    meta: { title: `${DOMAIN_TITLE} | home` }
  },
  {
    path: '/intro',
    name: 'intro',
    component: introPage,
    meta: { title: `${DOMAIN_TITLE} | intro` }
  },
  {
    path: '/contact',
    name: 'contact',
    component: contactPage,
    meta: { title: `${DOMAIN_TITLE} | contact` }
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: GalleryPage,
    meta: { title: `${DOMAIN_TITLE} | gallery` }
  },
  {
    path: '*',
    component: notFoundPage,
    meta: { title: `${DOMAIN_TITLE} | not found` }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js